/*
 * Дефолт снят с единственного узла макета, где Kbd используется буквально как есть:
 * ⌘K в поле поиска шапки (prototype/Prototype.dc.html:171).
 *
 * На двух других поверхностях макет красит kbd иначе — это не варианты компонента, а точечные
 * переопределения на месте вызова через className:
 *  - фон --panel — подсказка «T» у кнопки «Сегодня» в тулбаре шахматки (строка 515);
 *  - фон --sunk с рамкой --line-2 — хинт «T» в легенде шахматки (строка 563).
 */
.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 4px;
  background: var(--bg);
  border: 1px solid var(--line);
  color: var(--ink-3);
}
